import classNames from 'classnames';
import React from 'react';
import Avatar from '../../components/Avatar';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';
import userPath from '../../utils/url/userPath';
import TeammateInvitationMenu from './TeammateInvitationMenu';
import TeammateStatusLabel from './TeammateStatusLabel';
import TeammateTypeLabel from './TeammateTypeLabel';
import TeammateUserMenu from './TeammateUserMenu';
import * as styles from './TeammatesRow.module.scss';

const TEAMMATES_ROW_USER_FRAGMENT = gql(`
  fragment TeammatesRow_user on User {
    id
    name
    email
    type
    deactivatedAt
    ...Avatar_user
    ...userPath_user
    ...TeammateUserMenu_user
  }
`);

const TEAMMATES_ROW_INVITATION_FRAGMENT = gql(`
  fragment TeammatesRow_invitation on Invitation {
    id
    name
    email
    status
    type
    ...Avatar_invitation
    ...TeammateInvitationMenu_invitation
  }
`);

interface TeammatesRowProps {
  user?: DocumentType<typeof TEAMMATES_ROW_USER_FRAGMENT>;
  invitation?: DocumentType<typeof TEAMMATES_ROW_INVITATION_FRAGMENT>;
}

const TeammatesRow = ({ user, invitation }: TeammatesRowProps) => {
  const teammate = user ?? invitation;

  if (!teammate) {
    return null;
  }

  return (
    <div
      className={classNames(styles.row, {
        [styles.deactivated]: Boolean(user?.deactivatedAt),
      })}
    >
      <div className={styles.avatar}>
        {user ? (
          <Link to={userPath(user)} newTab>
            <Avatar user={user} />
          </Link>
        ) : (
          <Avatar user={teammate} />
        )}
      </div>
      <div className={styles.name}>
        {user ? (
          <Link to={userPath(user)} newTab>
            {teammate.name}
          </Link>
        ) : (
          teammate.name
        )}
      </div>
      <div className={styles.email}>{teammate.email}</div>
      <div className={styles.type}>
        <TeammateTypeLabel
          type={user?.type ?? invitation?.type}
          deactivated={user?.deactivatedAt}
        />
      </div>
      <div className={styles.status}>
        <TeammateStatusLabel
          deactivated={user?.deactivatedAt}
          invitationStatus={invitation?.status}
        />
      </div>
      <div className={styles.menu}>
        {user && <TeammateUserMenu user={user} />}
        {invitation && <TeammateInvitationMenu invitation={invitation} />}
      </div>
    </div>
  );
};

export default TeammatesRow;
